import {
  Avatar,
  Box,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/system';

import { shouldNotForwardProps } from '@helpers/misc';

import { DropdownStyledProps } from './types';

export const DropdownStyled = styled(Box, {
  shouldForwardProp: shouldNotForwardProps(['fullWidth']),
})<DropdownStyledProps>(({ fullWidth }) => ({
  position: 'relative',
  width: fullWidth ? '100%' : 'auto',
}));

export const DropdownLoadingBoxStyled = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: alpha('#fff', 0.5),
  zIndex: 1,
});

export const DropdownCircularProgressStyled = styled(CircularProgress)(
  ({ theme }) => ({
    padding: theme.spacing(0.5),
  })
);

export const DropdownSelectStyled = styled(Select)({
  height: '51px',
  backgroundColor: 'transparent',
  '.MuiSelect-select': { display: 'flex' },
});

export const DropdownMenuItemsStyled = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  '&.Mui-selected': { backgroundColor: theme.palette.secondary.light },
}));

export const DropdownMenuItemsTypographyStyled = styled(Typography)({
  flexGrow: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const DropdownMenuItemsAvatarStyled = styled(Avatar)({
  width: 'auto',
  height: 20,
  backgroundColor: 'transparent',
  flexShrink: 0,
  '& img': { objectFit: 'contain' },
});

export const DropdownLabelStyled = styled(Typography)({
  position: 'absolute',
  top: '-12px',
  left: '-14px',
  zIndex: 2,
  color: '#9e9e9e',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  padding: '0 6px',
  backgroundColor: '#fff',
  transform: 'scale(0.75)',
});
